import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryTermsDataGrid } from "src/components/views/erp/warehouse/masterData/DeliveryTermsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/warehouse/deliveryTerms")({
	staticData: { title: i18n.t("delivery_terms"), legacyViewKey: "deliveryTermsDataGrid" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DeliveryTermsDataGrid />;
}
